<div class="lcl-dashboard-manual-quote-card" [ngClass]="{ 'lcl-dashboard-manual-quote-card-denied': isDenied }">
  <app-lcl-header-detailed-info
    [template]="enumDetailedInfoPlacementEnum.quoteDashboardTemplate"
    [isDashboardPlacement]="true"
    [isQuote]="true"
    [isManualQuote]="true"
    [referenceValue]="quote?.referenceNumber"
    [referenceName]="'SPECIAL_OFFER'"
    [info]="quote"
  ></app-lcl-header-detailed-info>

  <app-lcl-shipment-totals-info [aggregatedStatistics]="quote?.aggregatedStatistics"></app-lcl-shipment-totals-info>

  <div class="lcl-dashboard-manual-quote-card-status">
    {{ currentStatusText | translate }}
  </div>
</div>
